import { useState } from 'react';
import { JobResponse } from 'store/jobs/job';
import { InfoText, InfoTitle, InfoWrapper } from 'components/new-ui/base/info-wrapper/styles';
import { StyledPaperRow } from 'components/new-ui/base/wrappers/styles';
import Button from 'components/new-ui/base/button/Button';
import AssignJobModal from 'views/manifests/components/AssignJobModal';
import useJobs from 'hooks/useJobs';

type Props = {
    canAssignJobs?: boolean;
    job: JobResponse;
    isFreightForwarderRole?: boolean;
};

const JobOverviewHeader = ({ canAssignJobs, job, isFreightForwarderRole }: Props) => {
    const { getJob } = useJobs({ jobId: job?.id, autoFetch: false });

    const [openAssignModal, setOpenAssignModal] = useState(false);

    let assignedTo: React.ReactNode = '-';

    if (job?.owner?.fullName) {
        assignedTo = job?.owner.fullName;
    } else if (job?.owner?.email) {
        assignedTo = job?.owner.email;
    } else if (canAssignJobs) {
        assignedTo = <Button type="assign" onClick={() => setOpenAssignModal(true)} />;
    }

    return (
        <>
            <StyledPaperRow>
                <InfoWrapper>
                    <InfoTitle>ENS:</InfoTitle>
                    <InfoText>{job?.externalReferences?.ens ?? '-'}</InfoText>
                </InfoWrapper>

                <InfoWrapper>
                    <InfoTitle>UK Export MRN:</InfoTitle>
                    <InfoText>{job?.externalReferences?.cdsExportMRN ?? '-'}</InfoText>
                </InfoWrapper>

                <InfoWrapper>
                    <InfoTitle>Customer:</InfoTitle>
                    <InfoText>{job?.customer?.name ?? '-'}</InfoText>
                </InfoWrapper>

                <InfoWrapper>
                    <InfoTitle>INCOTERM:</InfoTitle>
                    <InfoText>{job?.incotermCode ?? '-'}</InfoText>
                </InfoWrapper>

                <InfoWrapper>
                    <InfoTitle>Declarant:</InfoTitle>
                    <InfoText>{job?.creator?.fullName ?? job?.creator?.email ?? '-'}</InfoText>
                </InfoWrapper>

                {isFreightForwarderRole && (
                    <InfoWrapper>
                        <InfoTitle>Assigned To:</InfoTitle>
                        <InfoText>{assignedTo}</InfoText>
                    </InfoWrapper>
                )}
            </StyledPaperRow>

            {job && (
                <AssignJobModal
                    open={openAssignModal}
                    jobData={{
                        jobId: job.id,
                        teamId: job.teamId,
                    }}
                    onClose={() => setOpenAssignModal(false)}
                    onSuccess={() => {
                        setOpenAssignModal(false);
                        getJob(job.id);
                    }}
                />
            )}
        </>
    );
};

export default JobOverviewHeader;
